import React, { Component } from 'react';
import RequestApi from '../../Miscelania/RequestApi';
import config from 'react-global-configuration';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

// Importação do Router
import { Redirect, Link } from 'react-router-dom';
import InputMask from 'react-input-mask';
import AlertaInline from '../../Miscelania/AlertaInline';

const PropTypes = require('prop-types');

class ExamIndexStatusAcoes extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
      exam_date: '',
      hora_inicial: '',
      hora_final: '',
      exam_start: '',
      exam_finish: '',
      modal_input: false,
      dados: [],
      lista_instrutores: [],
      lista_provas: [],
      questao: {},
      questoes: {},
      archive: '',
      opcoes: [],
      questao_selecionada: 'undefined',
      message_contest: '',
      result: '',
      result_manual: 0,
      active: '',
      cell: this.props.cell,
      className: this.props.className,
    };
    //bind geral
    this.showModal = this.showModal.bind(this);
    this.atualizarQuestao = this.atualizarQuestao.bind(this);
    this.questaoSelecionada = this.questaoSelecionada.bind(this);
    this.verificarQuestaoSelecionada = this.verificarQuestaoSelecionada.bind(this);
    this.buscarQuestoes = this.buscarQuestoes.bind(this);
    this.justificar = this.justificar.bind(this);
    this.validar = this.validar.bind(this);
    this.recarregarQuestoes = this.recarregarQuestoes.bind(this);
    this.refreshAll = this.refreshAll.bind(this);
    this.buscarQuestoes = this.buscarQuestoes.bind(this);
    this.justificar = this.justificar.bind(this);
    this.validar = this.validar.bind(this);
    }

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleChangeResult (name, event) {
    var change = {};
    if(event.target.value > 100) { 
      change[name] = 100;
    } else {
      change[name] = event.target.value;
    }
    this.setState(change);
  } 

  componentDidMount () {
    this.refs.request_api.verifyPermission();
  }

  justificar(value) {
    var dados = {
      'question_id': value,
      'justification': this.state.message_justification,
    };
    var self = this;

    var confirm = window.confirm('Tem certeza que gostaria de justificar essa questão sem valida-la?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/usuario/justificar_questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.recarregarQuestoes(responseJson);
        }).catch((error) => {
          return error;
        });
      });
    }
  }

  validar(value) {
    var dados = {
      'question_id': value,
      'justification': this.state.message_justification,
      'questions': this.state.questoes,
    };
    var self = this;

    var confirm = window.confirm('Tem certeza que gostaria de validar essa questão?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/usuario/validar_questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.refreshAll(responseJson);
        }).catch((error) => {
          return error;
        });
      });
    }
  }
  recarregarQuestoes (event) {
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: event.message});
          self.setState({tipo_alerta: event.status});
          self.questaoSelecionada(self.state.questaoSelecionada);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  refreshAll (event) {
    var self = this;
    var header = this.recarregarQuestoes(event);
    Promise.resolve(header).then(function(value) {
      //self.props.recarregarProvas();
    });
  }
  buscarQuestoes () {
    var self = this;
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }   
  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  questaoSelecionada (questao_selecionada) {
    var atualizacao = this.atualizarQuestao(questao_selecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoSelecionada();
    });
  }

  buscarQuestoes () {
    var self = this;
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  verificarQuestaoSelecionada () {
    if(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') {
      this.context.router.history.push('/usuario/prova');
    } else {
      var questao = this.state.questoes[this.state.questaoSelecionada];
      var opcoes = questao.team_training_matter_staff_exam_question_option;
      this.setState({questao: questao});
      this.setState({opcoes: opcoes});
    }
  }
  showModal(event) {
    this.setState({ modal: true }, this.buscarQuestoes());
  }
  

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <span className={this.props.className} onClick={this.showModal}>
    {this.props.cell}
  </span>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
            <h4 className="pull-left"><b>Revisão de prova do aluno: {this.props.dadosProva.staff}</b></h4>
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      <div className="row dados-prova-modal">
        <div className="col-md-6">
            <p><b>Código: </b>{this.props.dadosProva.id}</p>
            <p><b>Treinamento: </b>{this.props.dadosProva.training}</p>
            <p><b>Matéria: </b>{this.props.dadosProva.matter}</p>
            <p><b>Status: </b><span className={(self.props.dadosProva.status == 'aprovada') ? 'label-success' : 'label-danger'}>{(self.props.dadosProva.status == 'aprovada') ? 'Aprovada' : 'Reprovada'}</span></p>
            <p><b>Início: </b>{this.props.dadosProva.exam_applied_start_str}</p>
            <p><b>Fim: </b>{this.props.dadosProva.exam_applied_finish_str}</p>
        </div>
        <div className="col-md-6">
            <p><b>Total de questões: </b>{this.props.dadosProva.qtd_questoes}</p>
            <p><b>Acertos: </b>{this.props.dadosProva.qtd_acertadas}</p>
            <p><b>Erros: </b>{this.props.dadosProva.qtd_erradas}</p>
            <p><b>Nota: </b>{this.props.dadosProva.result}</p>
            <p><b>Tempo total de prova:</b> {this.props.dadosProva.exam_time_str}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <p>Basta selecionar a questão para verificar se a mesma encontra-se contestada.</p>
        </div>
      </div>
      <div className="row">
        {Object.keys(self.state.questoes).map(function(k) {
          return (
            <div className="col-md-1">
              <div onClick={() => self.questaoSelecionada(k)} className={(self.state.questoes[k].contested === 1) ? "modal-prova-quadrado-questoes-fundo quadrado-contestada" : (self.state.questoes[k].selected == self.state.questoes[k].option_correct_number) ? "modal-prova-quadrado-questoes-fundo quadrado-correta" : "modal-prova-quadrado-questoes-fundo quadrado-incorreta"}>
                <h5>{(self.state.questoes[k].selected) ? self.state.questoes[k].question_number + ' - ' + self.state.questoes[k].selected_str : self.state.questoes[k].question_number}</h5>
              </div>
            </div>
          );
        })}
      </div>
      <hr/>
      {(this.state.questaoSelecionada === null || typeof  this.state.questaoSelecionada === 'undefined') ?  '' :
        <div>
          <div className="row">
            <div className="col-md-6">
              <h4>Questão {self.state.questao.question_number}:</h4>
            </div>
            <div className="col-md-6 text-right">
              {(typeof self.state.questao.question === 'undefined') ?  '' : <h4>Cod. {self.state.questao.question.number} </h4> }
            </div>
          </div>
          <hr/>
          <div dangerouslySetInnerHTML={{__html: self.state.questao.question_content}}></div>
          <hr/>
          <table className="table tabela-questao-opcoes">
            <tbody>
              {Object.keys(self.state.opcoes).map(function(k) {
                return (
                  <tr>
                    <td className="checkbox-questao-opcoes"><div className={(self.state.opcoes[k].selected == 1) ? 'opcao-selecionada' : 'opcao'}>{(self.state.opcoes[k].selected == 1) ? 'X' : ''}</div></td>
                    <td><span>{self.state.opcoes[k].option_number}) </span>{self.state.opcoes[k].option_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <hr/>
            <h3 className="text-center">Opção correta: <span className="opcao-correta">{this.state.questao.option_correct_number}</span></h3>
              {(this.state.questao.contested === 1) ? <div><hr/><h4 className="bg-danger">Contestação</h4><p>{this.state.questao.message}</p></div> : ""}
          <br/>
          <hr/>
          {(this.state.status_alerta == 1) ? <div><AlertaInline mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /><br/></div> : ""}
          <label>Justificar questão:</label>
          <textarea style={{ height: 200 }} disabled={this.state.questao.justified == 1 ? "disabled" : ""} value={this.state.questao.justified == 1 ? this.state.questao.justification : this.state.message_justification} type="text" name="content" className="form-control" placeholder="Escreva uma mensagem justificando" onChange={this.state.questao.justified == 1 ? "" : this.handleChange.bind(this, 'message_justification')} />
          <br/>
          <div className="row form-group">
            <div className="col-md-6">
              <button className="btn btn-danger btn-lg btn-block" disabled={this.state.questao.justified == 1 ? "disabled" : ""} onClick={()=>this.justificar(this.state.questao.id)}>NÃO VALIDAR QUESTÃO E ENVIAR JUSTIFICATIVA</button>
            </div>
            <div className="col-md-6">
              <button className="btn btn-success btn-lg btn-block" disabled={this.state.questao.justified === 1 ? "disabled" : "" } onClick={()=>this.validar(this.state.questao.id)}>VALIDAR QUESTÃO E ENVIAR JUSTIFICATIVA</button>
            </div>
          </div>
          {this.state.questao.justified == 1 ? 
            <div className="row form-group">
              <div className="col-md-12">
                <span className={(self.state.questao.validate == 1) ? 'label-success' : 'label-danger'}>{(self.state.questao.validate == 1) ? 'CONTESTAÇÃO VALIDADA' : 'CONTESTAÇÃO INVALIDADA'}</span>
              </div>
            </div>
            : ""
          }
        </div>
      }
    </Modal.Body>
  </Modal>
</div>
    );
  }
}

ExamIndexStatusAcoes.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamIndexStatusAcoes;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamIndexStatusAcoes.js